import { sortBy } from 'lodash';
import { getSelectedLanguage } from '@frontend/translate';

export function getFundingErrorInformationOptions(customFundingErrorInformation: string | null) {
    const language = getSelectedLanguage();
    const FundingErrorInformationEnum = language.fundingErrorInformationEnum;

    const options = Object.keys(FundingErrorInformationEnum).map((fundingErrorInformation) => {
        return {
            text: language.fundingErrorInformationEnum[
                fundingErrorInformation as keyof typeof FundingErrorInformationEnum
            ],
            value: fundingErrorInformation,
        };
    });

    if (
        customFundingErrorInformation &&
        !Object.keys(FundingErrorInformationEnum).includes(customFundingErrorInformation)
    ) {
        const errorInformation = customFundingErrorInformation || '';
        options.unshift({ text: errorInformation, value: errorInformation });
    }

    return [
        {
            text: `${language.common.select} ${language.request.fundingErrorInformationAbbreviation}...`,
            value: '',
        },
        ...sortArrayAlphabeticallyLastOptionOther(options),
    ];
}

function sortArrayAlphabeticallyLastOptionOther(array: { text: string; value: string }[]) {
    return sortBy(array, [(o) => o.value === 'other', (o) => o.text]);
}
